import { LogLevel } from '@azure/msal-browser';
import { Policy } from '../enums/policy.enum';
import { TenantId } from '../enums/tenant-id.enum';
import { ClientB2C } from '../types/ClientB2C';
import { ClientEnvironment } from '../types/ClientEnvironment';

type TenantName = 'testulplatform';
type AuthorityDomainTld = 'b2clogin.com';
type TenantDomainTld = 'onmicrosoft.com';

declare global {
	namespace NodeJS {
		interface ProcessEnv {
			GITHUB_AUTH_TOKEN: string;
			NODE_ENV: 'development' | 'production';
			PORT?: string;
			PWD: string;
			SERVICEBUS_HOSTNAME?: string;
			QUEUE_NAME?: string;
			AZURE_TENANT_ID?: string;
			AZURE_CLIENT_ID?: string;
			AZURE_CLIENT_SECRET?: string;
		}
	}
}

export const b2c: ClientB2C = {
	logLevel: LogLevel.Warning,
	clientId: 'd165d1f3-6590-4daf-b5c1-d7076b8b016a',
	tenantId: TenantId.Staging,
	tenantDomain: `testulplatform.onmicrosoft.com`,
	authorityDomain: 'testulplatform.b2clogin.com',
	policies: {
		[Policy.SignUpSignIn]: 'B2C_1A_Signup_Signin_Staging',
		[Policy.ResetPassword]: 'B2C_1A_Password_Reset_Staging',
		[Policy.EditProfile]: 'B2C_1A_Edit_Profile_Staging',
	},
	redirects: {
		login: '/auth/sign-in',
		logout: '/auth/sign-out',
	},
	scope: 'https://testulplatform.onmicrosoft.com/case-management-dev/Read openid profile offline_access', // Important - Include offline_access to also request a refresh token
	scopes: {
		read: 'https://testulplatform.onmicrosoft.com/case-management-dev/Read',
		write: 'https://testulplatform.onmicrosoft.com/case-management-dev/Write',
	},
	// signUpSignInPolicyName: 'B2C_1A_Signup_Signin_Staging',
	// passwordResetPolicyName: 'B2C_1A_Password_Reset_Staging',
	// forgotPasswordPolicyName: 'b2c_1a_forgot_password_development',
	// changeEmailAddressPolicyName: 'b2c_1a_change_email_address_development',
	// authorityBase:
	// 	'https://testulplatform.b2clogin.com/testulplatform.onmicrosoft.com',
	//migrationOnDemandClientId: '267459b7-0916-4a0b-9a3c-734a06932c8e',
	// loginRedirectUri: '/auth/sign-in', // Change this to the redirect URI for your app registration for signing in
	// logoutRedirectUri: '/auth/sign-out',
};

export const protectedResourceMap = new Map<string, string[]>([
	[
		'https://api-cm-dev-ncus.azurewebsites.net/v1/*',
		['https://testulplatform.onmicrosoft.com/case-management-dev/Read'],
	],
	// ['/fieldsprinklertesting/', [b2c.scopes.read]],
	// ['https://sentinel.qa.ul.com/*', [b2c.scopes.read]],
	// ['/api/*', [b2c.scopes.write]],
]);

export const environment: ClientEnvironment = {
	production: false,
	uLSubscriptionKey: '7bb538b1e2b64f7796c483c91c322f5a',
	baseUrl: 'https://di-dev.ulplatform.com/tic/casemanagement/v1/',
	getLocationUrl: 'location',
	getCategoryUrl: 'Category',
	getCaseListUrl: 'Case',
	getCaseDetailsUrl: 'Case',
	saveCaseUrl: 'case/SaveCase',
	uploadFileUrl: 'case/UploadFile',
	createCaseUrl: 'case/CreateCase',
	getCommentsUrl: 'case/comments',
	getContactInfoUrl: 'user/getuserinfo',
	downloadAttachment: 'Attachments/Download',
	createCommentsAttachments: 'case/SaveCommentAndAttachment',
	// telemetry: [
	// 	// withConsolePublisher(),

	// 	// withAppInsightsPublisher(
	// 	// 	'InstrumentationKey=08d9a23a-2d98-4959-aada-a2f04319d0a0;IngestionEndpoint=https://northcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://northcentralus.livediagnostics.monitor.azure.com/;ApplicationId=0cc20077-09f0-4f5d-a202-0b52271eb599',
	// 	// ),
	// ],
	// validateB2CTokenUrl: 'https://sentinel.qa.ul.com/Issue/ValidateB2CToken',
	// getCompanyByUserUrl: 'https://sentinel.qa.ul.com/Issue/GetCompanyByUser ',
	// getSymphonyTokenUrl:
	// 	'https://sentinel.qa.ul.com/Issue/GetPssTokenForSplash ',
	// eformsUrl:
	// 	'https://qaeforms.ul.com/?tokens=2&IsPSS=1&clientid=999999893&clientname=Splash&isrelated=true',

	// fromemail: 'noreply@notify-staging.ulplatform.com',
	// toemail: 'splash_reg_to@hizy2jrw.mailosaur.net',

	// azure: {
	// 	appInsights: {
	// 		connectionString:
	// 			'InstrumentationKey=7b8710ce-86b8-4cfd-9f99-667a4eb01fbe;IngestionEndpoint=https://eastus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/',
	// 	},
	// },
};
